import React from 'react';

const AssuredHouseIcon = ({ color = '#000000', width = '14', height = '14', ...props }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M2.58325 9.66814V5.29314H3.45825V9.66814H2.58325ZM5.79159 9.66814V5.29314H6.66659V9.66814H5.79159ZM0.844482 4.12647V3.29639L6.22909 0.660156L11.6137 3.29639V4.12647H0.844482ZM2.92202 3.25147H9.53615L6.22909 1.6473L2.92202 3.25147ZM0.844482 11.7098V10.8348H7.59875C7.61071 10.9904 7.62758 11.1386 7.64936 11.2796C7.67104 11.4206 7.70166 11.564 7.74123 11.7098H0.844482ZM8.99992 7.77799V5.29314H9.87492V7.34049L8.99992 7.77799ZM10.8958 13.527C10.2735 13.373 9.75898 13.0165 9.35211 12.4575C8.94533 11.8985 8.74194 11.2776 8.74194 10.5948V9.21941L10.8958 8.14257L13.0496 9.21941V10.5948C13.0496 11.2776 12.8462 11.8985 12.4394 12.4575C12.0325 13.0165 11.518 13.373 10.8958 13.527ZM10.4728 11.8781L12.3709 9.98897L11.8819 9.49984L10.4728 10.8909L9.90409 10.3222L9.41496 10.8202L10.4728 11.8781Z"
                fill={color}
            />
        </svg>
    );
};

export default AssuredHouseIcon;
